// dummy for future dynamic color loading, currently just returns hardcoded colors
export const loadColors = async () => {
  return {
    '--primary-1-50': '#E6F2F8',
    '--primary-1-100': '#CCE5F1',
    '--primary-1-200': '#99CBE3',
    '--primary-1-300': '#66B2D5',
    '--primary-1-400': '#3399C7',
    '--primary-1-500': '#0072A3',
    '--primary-1-600': '#005A82',
    '--primary-1-700': '#004262',
    '--primary-1-800': '#002A41',
    '--primary-1-900': '#001220',
    '--primary-2-50': '#E5F6FB',
    '--primary-2-100': '#CCEDF7',
    '--primary-2-200': '#99DBEF',
    '--primary-2-300': '#66C9E7',
    '--primary-2-400': '#33B7DF',
    '--primary-2-500': '#00A2D8',
    '--primary-2-600': '#0082AD',
    '--primary-2-700': '#006282',
    '--primary-2-800': '#004257',
    '--primary-2-900': '#00222B',
    '--action': '#0072A3',
    '--action-hover': '#005A82',
    '--action-soft': '#CCE5F1',
    '--action-gradient-start': '#0072A3',
    '--action-gradient-end': '#00A2D8',
    '--warning': '#D5B846',
    '--warning-hover': '#AB9334',
    '--warning-soft': '#FFF8DD',
    '--success': '#3A9F72',
    '--success-hover': '#2B7755',
    '--success-soft': '#DAF4E8',
    '--error': '#FF3860',
    '--error-hover': '#CF2D4D',
    '--error-soft': '#FFD7DF',
    '--on-action': '#FFFFFF'
  }
}
